module.exports = __webpack_public_path__ + "img/lesimg.99a36d7a.png";